import * as React from 'react';
import { cn } from '@/lib/utils';

interface DefinitionListProps {
  children: React.ReactNode;
  className?: string;
}

export function DefinitionList({ children, className }: DefinitionListProps) {
  return (
    <dl
      className={cn(
        'divide-y divide-border-subtle text-sm',
        className,
      )}
    >
      {children}
    </dl>
  );
}

interface DefinitionRowProps {
  term: React.ReactNode;
  children: React.ReactNode;
  mono?: boolean;
}

export function DefinitionRow({ term, children, mono }: DefinitionRowProps) {
  return (
    <div className="flex items-baseline justify-between gap-4 py-3 first:pt-0 last:pb-0">
      <dt className="text-muted-foreground">{term}</dt>
      <dd className={cn('text-right', mono ? 'font-mono text-xs' : 'text-sm')}>{children}</dd>
    </div>
  );
}
